import { useState } from "react";

const defaultPage = 1;
const defaultNumber = 10;

export default function usePagination(
  pg: number = defaultPage,
  lmt: number = defaultNumber
) {
  const [page, setPage] = useState(pg);
  const [limit, setLimit] = useState(lmt);

  const handlePage = (p: number) => {
    setPage(p);
  };

  const handleLimit = (l: number) => {
    setLimit(l);
  };

  return { page, handlePage, limit, handleLimit };
}
